import { jwtDecode } from "jwt-decode";

export function logout() {
    window.localStorage.removeItem("authToken");
}

export function authenticate(credentials) {
    return fetch("https://api.harpon.leyos.fr/api/auth", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(credentials),
    })
        .then(response => {
            if (!response.ok) {
                throw new Error("Authentication failed");
            }
            return response.json();
        })
        .then(data => {
            window.localStorage.setItem("authToken", data.token);
            return true;
        });
}

export function getAuthHeaders() {
    const token = window.localStorage.getItem("authToken");
    if (token) {
        return { Authorization: "Bearer " + token };
    }
    return {};
}

export function setup() {
    const token = window.localStorage.getItem("authToken");
    if (token) {
        const { id, username, roles: role, firstName, lastName, exp: expiration } = jwtDecode(token);
        if (expiration > new Date().getTime() / 1000) {
            return { id, username, role, firstName, lastName };
        }
    }
}

export function isAuthenticated() {
    const token = window.localStorage.getItem("authToken");
    if (token) {
        const { exp: expiration } = jwtDecode(token);
        if (expiration > new Date().getTime() / 1000) {
            return true;
        }
        return false;
    }
    return false;
}